import { LoadingMain } from '../icons';

export const PageLoader = () => {
  return (
    <div className='page-content-min-height shrink-0'>
      <div className='flex flex-col w-full items-center justify-center gap-y-4 absolute top-2/4 -translate-y-2/4 left-0'>
        <LoadingMain className='text-pics' />
        <div dir='ltr' className=' h-1 w-[200px] bg-neutral-200 dark:bg-neutral-600 rounded-full'>
          <div className={`h-1 !rounded-full bg-pics duration-2000 animate-increaseWidth`}></div>
        </div>
        <div className='body-12-regular whitespace-nowrap'>درحال بارگذاری اطلاعات ...</div>
      </div>
    </div>
  );
};
